"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableRef = void 0;
const react_1 = require("react");
const createRef = () => {
    const dict = {};
    const useCellMount = (rowIndex, columnId) => {
        const [, pushRender] = (0, react_1.useState)(false);
        (0, react_1.useEffect)(() => {
            var _a;
            const column = (_a = dict[columnId]) !== null && _a !== void 0 ? _a : {};
            column[rowIndex] = () => pushRender(x => !x);
            dict[columnId] = column;
            () => {
                delete column[rowIndex];
            };
        });
    };
    const renderColumn = (columnId) => {
        Object.entries(dict[columnId] || {}).forEach(([_, render]) => {
            render === null || render === void 0 ? void 0 : render();
        });
    };
    return {
        useCellMount,
        renderColumn,
    };
};
const useTableRef = () => {
    const ref = (0, react_1.useRef)(createRef());
    return ref;
};
exports.useTableRef = useTableRef;
//# sourceMappingURL=tableRef.js.map